import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useRack(nurseryId: string, tankId: string, rackId: string, enabled: boolean = true) {
  const { isPending, error, data } = useQuery({
    queryKey: ["racks", nurseryId, tankId, rackId],
    queryFn: () => API.getRack(nurseryId, rackId),
    enabled: enabled
  });

  return {
    isPending,
    error,
    data
  };
}

export default useRack;
